// Define all items with detailed content
  const fastItems = [
    {
      id: 1,
      title: "Background",
      description: "23 years old, born in Hong Kong, raised in Macau, currently based in Germany",
      img: require("../../../../assets/img/cvpic.jpeg"),
      details: `
        <h3 class="text-xl font-bold mb-3">My Journey</h3>
        <p class="mb-3">Born and raised in Asia, I've developed a unique perspective blending Eastern and Western cultures. My multicultural background influences my design and development approach.</p>
        <h3 class="text-xl font-bold mb-3">Current Focus</h3>
        <p>Currently based in Germany, I'm focused on creating digital experiences that leaves a remarking experience for its users while pursuing my passion for technology and design.</p>
      `
    },
    {
      id: 2,
      title: "What I do",
      description: "UI/UX design, full-stack app development, unity game development",
      img: require("../../../../assets/img/bg2.jpg"),
      details: `
        <h3 class="text-xl font-bold mb-3">UI/UX Design</h3>
        <p class="mb-3">Specializing in user-centered design with a focus on accessibility and intuitive interfaces. Tools: Figma, Adobe Indesign, Photoshop.</p>
        <h3 class="text-xl font-bold mb-3">Full-Stack Development</h3>
        <p class="mb-3">Proficient in Python, C , C++, HTML, CSS, JavaScript, ReactJS, PHP, SQL, Haskell, Django. Experienced in building scalable applications.</p>
        <h3 class="text-xl font-bold mb-3">Game Development</h3>
        <p>Passionate about creating immersive experiences using Unity and C#.</p>
        <h3 class="text-xl font-bold mb-3">Technologies and Frameworks</h3>
        <p>Experienced in using Strapi, Astro, MongoDB, Firebase, Linux, Git, Docker, Jupyter Notebook, JQuery, Tailwind CSS, Framer Motion, vite.</p>
      `
    },
    {
      id: 3,
      title: "Education",
      description: "Bachelors of Computer Science | Jacobs/Constructor University",
      img: require("../../../../assets/img/grad_jacobs.jpg"),
      details: `
        <h3 class="text-xl font-bold mb-3">Bachelor's Degree</h3>
        <p class="mb-3">Graduated in Bachelor of Computer Science, with a minor in Data Science.</p>
        <h3 class="text-xl font-bold mb-3">Relevant Courses</h3>
        <ul class="list-disc pl-5 mb-3">
          <li>Advanced Web Development</li>
          <li>Machine Learning Fundamentals</li>
          <li>Network Security</li>
          <li>Interaction Design</li>
          <li>Operating System (Linux)</li> 
          <li>Programming in C/C++,</li> 
          <li>Algorithms and Data structures</li>
          <li>Introduction to Computer science</li>
          <li>Intro to Data Science</li>
          <li>Software Engineering</li>
          <li>Applied Machine Learning</li>
          <li>Web Application Development</li>
          <li>Databases and Web Services</li>
          <li>Data Modelling and Analytics</li>
          <li>Secure and Dependable Systems</li>
          <li>Computer Architecture</li>
          <li>Automata Theory</li>
          <li>Numerical Methods</li>
          <li>Computer Networks</li>
        </ul>
        <h3 class="text-xl font-bold mb-3">Extracurricular</h3>
        <p>Badminton Club President, Bicycle Repair Workshop Founder</p>
      `,
      link: "https://constructor.university/"
    },
  ];

  const slowItems = [
    {
      id: 2,
      title: "Head of Software Development",
      description: "Macanista Robotics | 2025~ | Liverpool, UK",
      img: require("../../../../assets/img/inserr/IMG_5224.JPG"),
      details: `
        <h3 class="text-xl font-bold mb-3">Responsibilities</h3>
        <p class="mb-3">Lead development team in production of software and other programming needs for the company. Architechting scalable solutions for the company. In charge of making decisions regarding company IT infrastructure.</p>
        <p>Lead research and development for the software of all robotics products, mainly in charge of the Humanoid robotics department, driving innovation and technical advancements.</p>
        <h3 class="text-xl font-bold mb-3">Key Achievements</h3>
        <ul class="list-disc pl-5 mb-3">
          <li>Designed, developed, and maintain the company's main landing webpage, written using ReactJS and TailwindCSS, with a focus on
            user experience and performance optimization.</li>
          <li>Developing safety features for the Underwater Scooter that will lower chances of accidents from misuse by 70% </li>
        </ul>
        <h3 class="text-xl font-bold mb-3">Technologies</h3>
        <p>ROS, ReactJS, TailwindCSS, Python, Git, Scrum</p>
      `,
      link: "https://macanista.com/"
    },
    {
      id: 1,
      title: "Software Engineer",
      description: "DigiMC Ltd | 2024~ | Macau",
      img: require("../../../../assets/img/dmclogo.png"),
      details: `
        <h3 class="text-xl font-bold mb-3">Role</h3>
        <p class="mb-3">Software developer working on digital solutions and internal tools for businesses in Macau.</p>
        <h3 class="text-xl font-bold mb-3">Projects</h3>
        <ul class="list-disc pl-5 mb-3">
          <li>Built scalable, modular event management software in Python to streamline partner hotel operations, cutting manual processes by 40%.</li>
          <li>Developed and deployed dynamic full-stack web applications and websites, boosting their online presence, increasing user traffic by over 50%, and doubling average session duration — using MERN stack, WordPress, Strapi, Next.js, Astro, and PostgreSQL.</li>
          <li>Integrated Google Analytics and A/B testing features, enabling data-driven design decisions.</li> 
          <li>Implemented SEO best practices, improving search engine rankings and increasing organic traffic by 30%.</li>
        </ul>
        <h3 class="text-xl font-bold mb-3">Technologies</h3>
        <p>ReactJS, NextJS, Astro, TailwindCSS, Strapi, Node.js, Firebase, Git, Scrum</p>
      `,
      link: "https://maccutech.com"
    },
    {
      id: 3,
      title: "Student Assistant",
      description: "Constructor University Housing Department | 2023-2024 | Bremen, Germany",
      img: require("../../../../assets/img/constructorlogo.jpg"),
      details: `
        <h3 class="text-xl font-bold mb-3">Duration</h3>
        <p class="mb-3">
        <h3 class="text-xl font-bold mb-3">Duties</h3>
        <p class="mb-3">Managed daily office operations, including administrative tasks, student interactions, and file organization, while additionally ensuring the smooth functioning of IT infrastructure.</p>
        <h3 class="text-xl font-bold mb-3">Contributions</h3>
        <ul class="list-disc pl-5 mb-3">
          <li>Coordinated student housing services and managed office tasks, facilitating 600+ students each semester</li>
          <li>Optimized the student housing database using SQL, reducing query times by 75%</li>
          <li>Updated and organized content for the Student Housing website, improving navigation for 100+ visitors monthly</li>
        </ul>
      `,
      link: "https://constructor.university"
    },
    {
      id: 4,
      title: "Cyberfit Academy Intern and Working Student",
      description: 'Acronis GmbH | 23" | Munich, Germany',
      img: require("../../../../assets/img/acronislogo.jpeg"),
      details: `
      <h3 class="text-xl font-bold mb-3">Duties</h3>
      <p class="mb-3">Developed and maintained course materials for CyberFit Academy, including configuring Linux virtual machine environments with custom Python automation scripts. Collaborated with cross-functional teams to ensure optimal system performance and reliability.</p>
      <h3 class="text-xl font-bold mb-3">Contributions</h3>
      <ul class="list-disc pl-5 mb-3">
        <li>Automated Linux virtual machine management scripts using Python, improving system efficiency by 20%</li>
        <li>Resolved API issues and authored comprehensive documentation, enhancing usability for over 30 developers</li>
        <li>Designed and deployed new lab environments for 10+ CyberFit Academy courses, supporting over 100 partners</li>
        <li>Developed virtual machine automation scripts for the MSP School learning course, reducing setup time by 30%</li>
      </ul>
      <h3 class="text-xl font-bold mb-3">Technologies</h3>
      <p>Python, Linux Virtual Machines</p>
    `,
    link: "https://www.acronis.com/en-sg/"
    },
    {
      id: 5,
      title: "Full-Stack Developer",
      description: 'jacobsHack! Hackathon 21st Edition | 22" | Bremen, Germany',
      img: require("../../../../assets/img/jh22.png"),
      details: `
      <h3 class="text-xl font-bold mb-3">Contributions</h3>
      <ul class="list-disc pl-5 mb-3">
        <li>Prototyped webpage templates using Figma, reducing design approval time by 55%</li>
        <li>Engineered and launched static and registration pages using HTML, CSS, and ReactJS for 100+ participants</li>
        <li>Integrated MongoDB API to securely manage participant data, managed 500+ records</li>
      </ul>
      <h3 class="text-xl font-bold mb-3">Technologies</h3>
      <p>ReactJS, MongoDB, Git, Figma</p>
    `
    },
    {
      id: 6,
      title: "Humanoid Robotics Instructor",
      description: 'Macau Anglican College | 21" | Taipa, Macau',
      img: require("../../../../assets/img/maclogo.png"),
      details: `
      <h3 class="text-xl font-bold mb-3">Contributions</h3>
      <ul class="list-disc pl-5 mb-3">
        <li>Instructed 10+ students on designing and constructing bipedal robots using 3D-printed components</li>
        <li>Led the design of custom robot parts with AutoCAD, increasing project completion rates by 40%</li>
        <li>Guided students in programming robots with Robo+ software, fostering their systematic thinking skills</li>
      </ul>
      <h3 class="text-xl font-bold mb-3">Technologies</h3>
      <p>ROS, Robo+</p>
    `,
    link: "https://acm.edu.mo"
    },
  ];

  const defaultItems = [
      {
      id: 1,
      title: "FutureStep Insoles Webpage",
      description: "Astro, Strapi, TailwindCSS",
      img: require("../../../../assets/img/futurestepss.png"), 
      details: `
        <h3 class="text-xl font-bold mb-3">Project Overview</h3>
        <p class="mb-3">Contracted work with DigiMC for FutureStep Insoles.</p>
        <p class="mb-3">Customized and configured Strapi backend with Astro frontend.</p>
        <h3 class="text-xl font-bold mb-3">Features</h3>
        <ul class="list-disc pl-5 mb-3">
          <li>Product Showcase and individual pages</li>
          <li>Blog section with article pages</li>
        </ul>      `,
    },
      {
      id: 2,
      title: "Skip Waste Selection Page",
      description: "ReactJS, TailwindCSS, Vite",
      img: require("../../../../assets/img/skipss.png"), 
      details: `
        <h3 class="text-xl font-bold mb-3">Project Overview</h3>
        <p class="mb-3">This is a coding challenge by REMWaste for an application as a Full Stack Dev.</p>
        <p class="mb-3">Task was to completely redesign the given page and keep functionality intact.</p>
        <h3 class="text-xl font-bold mb-3">Features</h3>
        <ul class="list-disc pl-5 mb-3">
          <li>Interactive product selector</li>
          <li>Step progress bar</li>
          <li>Responsive Mobile Design</li>
        </ul>
        <a href="https://github.com/Geoshua/Skip-Waste-Selection" class="text-blue-500 hover:underline mb-3 block">View Code on GitHub</a>
      `,
      link: "https://skipwasteselection.netlify.app/"
    },
    {
      id: 3,
      title: "Macanista Robotics Webpage",
      description: "ReactJS, TailwindCSS, Shopify",
      img: require("../../../../assets/img/macanistasitess.png"), 
      details: `
        <h3 class="text-xl font-bold mb-3">Project Overview</h3>
        <p class="mb-3">Official website for robotics startup showcasing products and services.</p>
        <h3 class="text-xl font-bold mb-3">Features</h3>
        <ul class="list-disc pl-5 mb-3">
          <li>Interactive product configurator</li>
          <li>Integrated e-commerce functionality</li>
          <li>Custom CMS for non-technical staff</li>
          <li>Multi-language support</li>
        </ul>
        <h3 class="text-xl font-bold mb-3">Results</h3>
        <p>Increased conversion rate by 35% and reduced bounce rate by 25%.</p>
      `,
      link: "https://www.macanista.com/"
    },
    {
      id: 4,
      title: "Reversible Covert Channel Over TLS",
      description: "Python, mininet, scapy | Bachelor's Thesis at Constructor University",
      img: require("../../../../assets/img/rcc_diagram.png"),  
      details: `
        <h3 class="text-xl font-bold mb-3">Research Focus</h3>
        <p class="mb-3">Investigating covert communication channels within encrypted TLS traffic.</p>
        <h3 class="text-xl font-bold mb-3">Methodology</h3>
        <ul class="list-disc pl-5 mb-3">
          <li>Developed custom Python tools for traffic analysis</li>
          <li>Created simulated network environments using Mininet</li>
          <li>Analyzed detection resistance of various techniques</li>
        </ul>
        <h3 class="text-xl font-bold mb-3">Findings</h3>
        <p>Identified novel reversible channel with 95% success rate and low detectability.</p>
      `,
      link: "https://github.com/Geoshua/Reversible-Covert-Channel"
    },
    {
      id: 5,
      title: "GAINS Fitness Tracker",
      description: "JS, HTML, CSS, Firebase",
      img: require("../../../../assets/img/gains_icon.png"),  
      details: `
        <h3 class="text-xl font-bold mb-3">Application Purpose</h3>
        <p class="mb-3">Comprehensive fitness tracking app with personalized workout plans.</p>
        <h3 class="text-xl font-bold mb-3">Key Features</h3>
        <ul class="list-disc pl-5 mb-3">
          <li>Exercise demonstration videos</li>
          <li>Progress tracking with analytics</li>
          <li>Social sharing functionality</li>
          <li>Nutrition planning tools</li>
        </ul>
        <h3 class="text-xl font-bold mb-3">Impact</h3>
      `,
      link: "https://github.com/Geoshua/GainsApp"
    },
    {
      id: 6,
      title: "Bug World Client Side Simulation Engine",
      description: "JS, HTML, CSS",
      img: require("../../../../assets/img/bug_world.png"),  
      details: `

      `,
      link: "https://github.com/Geoshua/Bug-World"
    },
    {
        id: 7,
        title: "CampusNot",
        description: "JS, HTML, CSS, Firebase",
        img: require("../../../../assets/img/campusNotlogo.jpeg"),  
        details: `
          <h3 class="text-xl font-bold mb-3">Project Overview</h3>
          <p class="mb-3">CampusNot is a web application designed to facilitate communication and event organization within university campuses.</p>
          <h3 class="text-xl font-bold mb-3">Technologies Used</h3>
          <ul class="list-disc pl-5 mb-3">
            <li>JavaScript, HTML, CSS</li>
            <li>Firebase for real-time database and authentication</li>
            <li>Responsive design for mobile and desktop compatibility</li>
          </ul>
          <h3 class="text-xl font-bold mb-3">Results</h3>
          <p>Enhanced campus engagement with over 1,000 active users in the first month.</p>
        `,
        link: "https://github.com/Geoshua/ReCampusNot"
      },
      {
        id: 8,
        title: "jacobsHack! Website",
        description: "ReactJS, JS, HTML, CSS, MongoDB, Figma",
        img: require("../../../../assets/img/jh22.png"),
      },
      {
        id: 9,
        title: "Personal Website",
        description: "JS, HTML, CSS",
        img: require("../../../../assets/img/PortfolioThumbnail.png"),  
        details: `
          <h3 class="text-xl font-bold mb-3">Project Overview</h3>
          <p class="mb-3">Personal portfolio website showcasing projects and skills.</p>
          <h3 class="text-xl font-bold mb-3">Technologies Used</h3>
          <ul class="list-disc pl-5 mb-3">
            <li>HTML, CSS, JavaScript</li>
            <li>Responsive design with Bootstrap</li>
            <li>SEO optimization techniques</li>
          </ul>
          <h3 class="text-xl font-bold mb-3">Results</h3>
          <p>Increased personal brand visibility and received positive feedback from peers.</p>
        `,
        link: "https://github.com/Geoshua/geoshua.github.io"
      },
      {
        id: 10,
        title: "ATM Command Line",
        description: "Python",
        details: ``,
        link: "https://github.com/Geoshua/ATM-CLI"
      },
  ];

export {fastItems, slowItems, defaultItems};